// src/components/CallScore/SelectConversation.js
import React from 'react';
import { Building2, Heart, Scale, Sparkles } from 'lucide-react';
import { HUMAN_SALES_CALL_TRANSCRIPT, HUMAN_SUPPORT_CALL_TRANSCRIPT } from "../../data/transcript"

const CONVERSATION_TYPES = [
  {
    id: 'fintech',
    label: 'Fintech',
    icon: Building2,
    color: '#0075FF',
    data: HUMAN_SALES_CALL_TRANSCRIPT,
    conversationId: "5544924652634112"
    // conversationId: "6448854593044480"
  },
  {
    id: 'healthcare',
    label: 'Healthcare',
    icon: Heart,
    color: '#0075FF',
    data: HUMAN_SUPPORT_CALL_TRANSCRIPT,
    conversationId: "6446833385209856"
    // conversationId: "4571771105312768"
  },
  {
    id: 'legal',
    label: 'Legal',
    icon: Scale,
    color: '#0075FF',
    data: HUMAN_SUPPORT_CALL_TRANSCRIPT,
    conversationId: "4559610159169536"
    // conversationId: "4663331461398528"
  },
];

const SelectConversation = ({ selectedType, onTypeSelect, onGenerate }) => {

  React.useEffect(() => {
    if (!selectedType) {
      const healthcareOption = CONVERSATION_TYPES.find(type => type.id === 'healthcare');
      onTypeSelect(healthcareOption);
    }
  }, []);

  return (
    <div>
      <h1 style={styles.title}>Choose a call to score:</h1>
      <div style={styles.buttonContainer}>
        {CONVERSATION_TYPES.map((type) => {
          const Icon = type.icon;
          const isSelected = selectedType?.id === type.id;
          
          return (
            <button
              key={type.id}
              onClick={() => onTypeSelect(type)}
              style={{
                ...styles.typeButton,
                backgroundColor: isSelected ? '#0075FF' : '#2D3748',
                color: isSelected ? '#FFFFFF' : '#E2E8F0',
                border: `1px solid ${isSelected ? '#0075FF' : '#4A5568'}`,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease',
                ':hover': {
                  backgroundColor: isSelected ? '#0075FF' : '#3D4A5F',
                  transform: 'translateY(-1px)',
                }
              }}
            >
              <Icon style={{
                width: 16,
                height: 16,
                color: isSelected ? '#FFFFFF' : '#E2E8F0',
              }} />
              <span style={styles.buttonText}>{type.label}</span>
            </button>
          );
        })}
      </div>
      <button
        onClick={onGenerate}
        disabled={!selectedType}
        style={{
          ...styles.generateButton,
          backgroundColor: selectedType ? '#0075FF' : '#E2E8F0',
          cursor: selectedType ? 'pointer' : 'not-allowed',
          padding: '12px 40px 12px 40px',
          gap: '10px',
          borderRadius: '12px 0px 12px 0px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', 
          fontSize: '14px',
          fontWeight: '600',
        }}
      >
        <Sparkles style={{ width: 16, height: 16 }} />
        Generate Call Score
      </button>
    </div>
  );
};

const styles = {
  title: {
    fontSize: '18px',
    fontWeight: '500',
    textAlign: 'center',
    color: '#FFFFFF',
    marginBottom: '22px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
  },
  typeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: '16px',
    border: 'none',
    borderRadius: '8px',
    width: '130%',
    transition: 'background-color 0.2s',
    cursor: 'pointer',
  },
  buttonText: {
    fontSize: '14px',
    fontWeight: '600',
  },
  generateButton: {
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    marginTop: '32px',
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: '500',
    transition: 'background-color 0.2s',
  },
};

export default SelectConversation;